import { render, staticRenderFns } from "./InvoiceSimpleTable.vue?vue&type=template&id=34faf9d9&scoped=true&"
import script from "./InvoiceSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSimpleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34faf9d9",
  null
  
)

export default component.exports